import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-report-overview',
  templateUrl: 'report-overview.component.html'
})
export class ReportOverviewComponent implements OnInit {

  public initialized: boolean = false;

  ngOnInit(): void {
    this.initialized = true;
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/report/report-overview.component.ts